<script>
  export let schema;
  export let id;
  export let value;
  export let accept = null;

  let input;

  if (schema.ui && !schema.ui.type) {
    schema.ui.type = 'FormData';
  }

  const setImages = async () => { value = Array.from(input.files) }

  const drop = e => { input.files = e.dataTransfer.files }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="dropzone" on:click={ () => { input.click()} } on:drop|preventDefault={ drop } on:dragover|preventDefault>
  <div class="icon"><i class="bi bi-images"></i></div>
  <div>Click or drop your images here</div>
  <div>to upload them</div>
</div>
<input { id } type="file" name={ id } multiple { accept } bind:this={ input } on:change={ setImages }>

<style>
  input { visibility: hidden; }
</style>